<ul class="file-list {{mobile ? 'mobile' : ''}}"
    [style.padding-inline-start]="onlyPictures ? '0px' : '40px'">

    @if (!onlyPictures) {

        @for (file of files; track file; let i = $index) {
            <li>
                <div class="file-list__item-container">
                    <mat-icon [class]="file.icon">
                        {{file.icon}}
                    </mat-icon>
                    <a href="file/{{aliasEncoded}}/{{file.pathEncoded}}/{{file.nameEncoded}}"
                        target="_blank"
                        class="accent"
                        (click)="downloadFile(file, i); false">
                        {{file.name}}
                    </a>
                </div>
                <!-- FYI: Must be after the link to have larger stacking index -->
                @if (loadingFile === i) {
                    <mat-progress-bar mode="indeterminate"></mat-progress-bar>
                }
            </li>
        }
    }

    @if (onlyPictures && files.length > 0 && images.length === files.length) {
        <div #pictureBrowser
            noPrint
            tabindex="0"
            (keydown)="browsePictures('key', $event)">

            @if (!mobile) {
                <div class="container">
                    <img class="picture"
                        (click)="openPictureDialog();"
                        [src]="images[showPictureIndex]">
                </div>
                @if (images.length > 1) {
                    <div class="picture-browser">
                        <button id="picture-previous-button"
                            mat-icon-button
                            (click)="browsePictures('previous'); pictureBrowser.focus();">
                            <mat-icon>navigate_before</mat-icon>
                        </button>
                        <div class="thumbnails">
                            <mat-radio-group [(ngModel)]="selectedValue">
                                @for (image of images; track image; let i = $index;) {
                                    <span>
                                        <mat-radio-button [id]="'radio-' + i"
                                            [value]="image"
                                            (mouseenter)="selectedValue = image; this.showPictureIndex = i;">
                                        </mat-radio-button>
                                    </span>
                                }
                            </mat-radio-group>
                        </div>
                        <button id="picture-next-button"
                            mat-icon-button
                            (click)="browsePictures('next'); pictureBrowser.focus();">
                            <mat-icon>navigate_next</mat-icon>
                        </button>
                    </div>
                }
            }
            @else {
                <div>
                    <div>
                        <div class="picture-filename">
                            <b>{{files[showPictureIndex].name}}</b>
                        </div>
                        <img class="picture mobile"
                            [src]="images[showPictureIndex]"
                            (touchstart)="onTouchStart($event)"
                            (touchmove)="onTouchMove($event)"
                            (touchend)="onTouchEnd($event)">
                    </div>
                </div>
                <div class="picture-browser">
                    <button id="picture-previous-button"
                        mat-icon-button
                        (click)="browsePictures('previous'); pictureBrowser.focus();">
                        <mat-icon>navigate_before</mat-icon>
                    </button>
                    @if (images.length > 1) {
                        <mat-radio-group [(ngModel)]="selectedValue"
                            class="mobile-radio-group">
                            @for (image of images; track image; let i = $index;) {
                                <span class="mobile-radio-btn">
                                    <mat-radio-button [id]="'radio-mobile-' + i"
                                        [value]="image"
                                        (change)="showPictureIndex = i; selectedValue = image;">
                                    </mat-radio-button>
                                </span>
                            }
                        </mat-radio-group>
                    }
                    <button id="picture-next-button"
                        mat-icon-button
                        (click)="browsePictures('next'); pictureBrowser.focus();">
                        <mat-icon>navigate_next</mat-icon>
                    </button>
                </div>
                <div class="zoom-container">
                    <a href="{{images[showPictureIndex]}}"
                        target="_blank">
                        <button id="zoom-button"
                            mat-button>
                            <mat-icon class="zoom-icon">zoom_in</mat-icon>
                            {{ 'default.zoomPicture' | blah }}
                        </button>
                    </a>
                </div>
            }
        </div>
        <div class="print-only">
            @for (image of images; track image; let i = $index;) {
                <div class="print-page">
                    <img class="print-image"
                        [src]="image"
                        alt="Picture {{i + 1}}">
                </div>
            }
        </div>
    }
</ul>